//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CoreButton',
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: ''
    },
    prependIcon: {
      type: String,
      default: ''
    },
    appendIcon: {
      type: String,
      default: ''
    },
    solidIcon: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      hasEmptySlot: false,
      commonAttrs: {}
    };
  },
  computed: {
    iconPrefix: function iconPrefix() {
      return this.solidIcon ? 'fas' : 'fal';
    },
    hasToolTip: function hasToolTip() {
      return this.tooltip && String(this.tooltip).length;
    },
    classButtonRounded: function classButtonRounded() {
      return this.active ? "bg-rounded-button-solid-".concat(this.color, " white--text") : "bg-rounded-button-".concat(this.color);
    },
    classCursorPointer: function classCursorPointer() {
      return this.$attrs.href || this.$attrs.to || this.$listeners.click ? 'cursor-pointer' : '';
    }
  },
  created: function created() {
    this.hasEmptySlot = Boolean(!this.$slots.default);
  },
  beforeUpdate: function beforeUpdate() {
    this.hasEmptySlot = Boolean(!this.$slots.default);
  }
};